var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1281 -55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.763,0a2.669,2.669,0,0,0-2.668,2.654V4.219H10.361a.388.388,0,0,0-.06,0,.622.622,0,0,0-.562.569L8.491,19.228a.618.618,0,0,0,.162.473.624.624,0,0,0,.46.2H24.449a.622.622,0,0,0,.623-.674L23.822,4.788a.623.623,0,0,0-.622-.569H20.467V2.654A2.666,2.666,0,0,0,17.8,0Zm0,1.244H17.8a1.4,1.4,0,0,1,1.416,1.41V4.219H14.343V2.654a1.4,1.4,0,0,1,1.419-1.41Zm-4.83,4.22h2.161V7.309h0a.624.624,0,0,0,1.249,0V5.464h4.876V7.309a.624.624,0,0,0,1.249,0V5.465h2.161l1.138,13.195H9.8Z",
    transform: "translate(1275.512 56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(1281 55)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.84e1319feac361b6126c52494056f236.svg";
export { ForwardRef as ReactComponent };